(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fastutv-vehicle-entry"] && !Shopify.designMode) return;
  try {
    
  const updateVehicleEntry = event => {
    const root = event.target.closest('[data-vehicle-entry]');
    if (!root) return;
    const make = root.querySelector('[data-vehicle-make]');
    const model = root.querySelector('[data-vehicle-model]');
    const link = root.querySelector('[data-vehicle-shop]');
    if (!link.dataset.defaultUrl) link.dataset.defaultUrl = link.getAttribute('href');
    if (event.target === make) {
      model.replaceChildren(model.options[0]);
      for (const option of root.querySelector('template').content.querySelectorAll('option')) {
        if (option.dataset.make === make.value) model.append(option.cloneNode(true));
      }
      model.value = '';
      model.disabled = !make.value;
    }
    const url = new URL(model.value || make.selectedOptions[0].dataset.url || link.dataset.defaultUrl, location.origin);
    if (url.origin === location.origin) link.href = url.href;
  };
  const initializeVehicleEntry = scope => {
    const roots = scope.matches?.('[data-vehicle-entry]') ? [scope] : scope.querySelectorAll('[data-vehicle-entry]');
    for (const root of roots) {
      if (root.dataset.vehicleReady === 'true') continue;
      const make = root.querySelector('[data-vehicle-make]');
      if (!make || !root.querySelector('[data-vehicle-model]') || !root.querySelector('[data-vehicle-shop]')) continue;
      updateVehicleEntry({ target: make });
      make.disabled = false;
      root.dataset.vehicleReady = 'true';
    }
  };
  document.addEventListener('change', updateVehicleEntry);
  document.addEventListener('shopify:section:load', event => initializeVehicleEntry(event.target));
  initializeVehicleEntry(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeVehicleEntry(document), { once: true });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
